import React, { useEffect, useState} from 'react'
import cross from '../images/transparentCross.png'
import check from '../images/transparentCheck.png'

const determineOffboarded = (offboradedContent, selectedFunctionDate) => {
    switch (offboradedContent) {
        case 'OffboardedForever':
            return false
        case 'Active':
            return true
        case 'verified':
            return true
        case null:
            return true        
        default:
            return false
    }
}
const VanDocumentsCompliance = (props) => {
    const [ returnArray, setReturnArray ] = useState([])

    useEffect( () => {
        let thisDate = new Date('Thu Jan 3 2030')
        let thatDate = new Date('1/6/2101')
        let localArrayReturn = []
        if (props.data) {
            let localObj = {...props.data}
            let localArrayDrivers = [...localObj.drivers]
            let localArray = []
            props.data.drivers.forEach( (driver, driverID) => { 
                if (determineOffboarded(driver.status) && driver.location === props.selectedCity) { 
                    localArray.push(driver)
                }
            })
            localArray.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
            localArray.forEach( (driver, driverID) => {
                let localArrayDriver = []
                for (let i = 0; i <  9; i++) {
                    localArrayDriver.push(
                        <div className='drivers_for_compliance_check_documents_missing'>
                            Missing
                        </div>
                    )
                }
                if (driver.vanOwner) {
                    if (!driver.vanOwner) {
                        localArrayDriver[0] = (
                            <div className='drivers_for_compliance_check_documents_false'>
                                <img src={cross}  className='complianceImages' alt='complaince check document'/>
                            </div>
                        )
                    } else {
                        localArrayDriver[0] = (
                            <div className='drivers_for_compliance_check_documents_check'>
                                <img src={check}  className='complianceImages' alt='this is a check'/>
                            </div>
                        )
                    }
                    if (driver.registration !== null) {
                        localArrayDriver[1] = (
                            <div className='drivers_for_compliance_check_documents_two'>
                                {driver.registration}
                            </div>
                        )
                    }
                    if (driver.vtype !== null) {
                        if (driver.vtype.toLowerCase() === 'standard' || driver.vtype.toLowerCase() === 'standart') {
                            localArrayDriver[2] = (
                                <div className='drivers_for_compliance_check_documents_three'>
                                    {driver.vtype}
                                </div>
                            )
                        } else {
                            localArrayDriver[2] = (
                                <div className='drivers_for_compliance_check_documents_four'>
                                    {driver.vtype}
                                </div>
                            )
                        }
                    }
                    driver.imgArray.forEach( element => {
                        if (!element.storageBool) {
                            if (element.name === 'MOT' && element.verified === 'True') {
                                localArrayDriver[3] = (
                                    <div className='drivers_for_compliance_check_documents'>
                                        {new Date(element.expiryDate).toLocaleDateString('en-GB') === 'Mon Sep 09 2052' ? 'n/a' : new Date(element.expiryDate).toLocaleDateString('en-GB')}
                                    </div>
                                )
                            } else if (element.name === 'MOT') {
                                localArrayDriver[3] = (
                                    <div className='drivers_for_compliance_check_documents_two'>
                                        {new Date(element.expiryDate).toLocaleDateString('en-GB') === 'Mon Sep 09 2052' ? 'n/a' : new Date(element.expiryDate).toLocaleDateString('en-GB')}
                                    </div>
                                )
                            }
                            if (element.name === 'Motor Insurance' && element.verified === 'True') {
                                localArrayDriver[4] = (
                                    <div className='drivers_for_compliance_check_documents'>
                                        {new Date(element.expiryDate).toLocaleDateString('en-GB') === 'Mon Sep 09 2052' ? 'n/a' : new Date(element.expiryDate).toLocaleDateString('en-GB')}
                                    </div>
                                )
                            } else if (element.name === 'Motor Insurance') {
                                localArrayDriver[4] = (
                                    <div className='drivers_for_compliance_check_documents_two'>
                                        {new Date(element.expiryDate).toLocaleDateString('en-GB') === 'Mon Sep 09 2052' ? 'n/a' : new Date(element.expiryDate).toLocaleDateString('en-GB')}
                                    </div>
                                )
                            }
                            if (element.name === 'G.I.T. Insurance' && element.verified === 'True') {
                                localArrayDriver[5] = (
                                    <div className='drivers_for_compliance_check_documents'>
                                        {new Date(element.expiryDate).toLocaleDateString('en-GB') === 'Mon Sep 09 2052' ? 'n/a' : new Date(element.expiryDate).toLocaleDateString('en-GB')}
                                    </div>
                                )
                            } else if (element.name === 'G.I.T. Insurance') {
                                localArrayDriver[5] = (
                                    <div className='drivers_for_compliance_check_documents_two'>
                                        {new Date(element.expiryDate).toLocaleDateString('en-GB') === 'Mon Sep 09 2052' ? 'n/a' : new Date(element.expiryDate).toLocaleDateString('en-GB')}
                                    </div>
                                )
                            }
                            if (element.name === 'P.L. Insurance' && element.verified === 'True') {
                                localArrayDriver[6] = (
                                    <div className='drivers_for_compliance_check_documents'>
                                        {new Date(element.expiryDate).toLocaleDateString('en-GB') === 'Mon Sep 09 2052' ? 'n/a' : new Date(element.expiryDate).toLocaleDateString('en-GB')}
                                    </div>
                                )
                            } else if (element.name === 'P.L. Insurance') {
                                localArrayDriver[6] = (
                                    <div className='drivers_for_compliance_check_documents_two'>
                                        {new Date(element.expiryDate).toLocaleDateString('en-GB') === 'Mon Sep 09 2052' ? 'n/a' : new Date(element.expiryDate).toLocaleDateString('en-GB')}
                                    </div>
                                )
                            }
                            if (element.name === 'V5' && element.verified === 'True') {
                                localArrayDriver[7] = (
                                    <div className='drivers_for_compliance_check_documents'>
                                        <img src={check}  className='complianceImages' alt='this is a check'/>
                                    </div>
                                )
                            } else if (element.name === 'V5') {
                                localArrayDriver[7] = (
                                    <div className='drivers_for_compliance_check_documents_check'>
                                        <img src={check}  className='complianceImages' alt='this is a check'/>
                                    </div>
                                )
                            }
                            if (element.name === 'TAX' && element.verified === 'True') {
                                localArrayDriver[8] = (
                                    <div className='drivers_for_compliance_check_documents'>
                                        {new Date(element.expiryDate).toLocaleDateString('en-GB') === 'Mon Sep 09 2052' ? 'n/a' : new Date(element.expiryDate).toLocaleDateString('en-GB')}
                                    </div>
                                )
                            } else if (element.name === 'TAX') {
                                localArrayDriver[8] = (
                                    <div className='drivers_for_compliance_check_documents_two'>
                                        {new Date(element.expiryDate).toLocaleDateString('en-GB') === 'Mon Sep 09 2052' ? 'n/a' : new Date(element.expiryDate).toLocaleDateString('en-GB')}
                                    </div>
                                )
                            }
                        }
                    })
                } else {
                    if (driver.complianceCheck !== null) {
                        props.data.vehicles.forEach( element => {
                            if (element.registration === driver.complianceCheck) {
                                if (!driver.vanOwned) {
                                    localArrayDriver[0] = (
                                        <div className='drivers_for_compliance_check_documents_false'>
                                            <img src={cross}  className='complianceImages' alt='this is a cross'/>
                                        </div>
                                    )
                                } else {
                                    localArrayDriver[0] = (
                                        <div className='drivers_for_compliance_check_documents_check'>
                                            <img src={check}  className='complianceImages' alt='this is a check'/>
                                        </div>
                                    )
                                }
                                if (element.registration) {
                                    localArrayDriver[1] = (
                                        <div className='drivers_for_compliance_check_documents_two'>
                                            {element.registration ? element.registration : 'none'}
                                        </div>
                                    )
                                }
                                if (element.vtype) {
                                    localArrayDriver[2] = (
                                        <div className='drivers_for_compliance_check_documents_two'>
                                            {element.vtype}
                                        </div>
                                    )
                                }
                                element.imgArray.forEach( vanImage => {
                                    if (!vanImage.storageBool) {
                                        if (vanImage.name === 'MOT') {
                                            if (vanImage.verified === 'True') {
                                                localArrayDriver[3] = (
                                                    <div className='drivers_for_compliance_check_documents'>
                                                        { vanImage.expiryDate ? new Date(vanImage.expiryDate).toLocaleDateString('en-GB') : 'none'}
                                                    </div>
                                                )
                                            } else {
                                                localArrayDriver[3] = (
                                                    <div className='drivers_for_compliance_check_documents_two'>
                                                        { vanImage.expiryDate ? new Date(vanImage.expiryDate).toLocaleDateString('en-GB') : 'none'}
                                                    </div>
                                                )
                                            }
                                        }
                                        if (vanImage.name === 'Motor Insurance') {
                                            if (vanImage.verified === 'True') {
                                                localArrayDriver[4] = (
                                                    <div className='drivers_for_compliance_check_documents'>
                                                        {new Date(vanImage.expiryDate).toLocaleDateString('en-GB') === 'Mon Sep 09 2052' ? 'n/a' : new Date(vanImage.expiryDate).toLocaleDateString('en-GB')}
                                                    </div>
                                                )
                                            } else {
                                                localArrayDriver[4] = (
                                                    <div className='drivers_for_compliance_check_documents_two'>
                                                        {new Date(vanImage.expiryDate).toLocaleDateString('en-GB') === 'Mon Sep 09 2052' ? 'n/a' : new Date(vanImage.expiryDate).toLocaleDateString('en-GB')}
                                                    </div>
                                                )
                                            }
                                        }
                                        if (vanImage.name === 'G.I.T. Insurance') {
                                            if (vanImage.verified === 'True') {
                                                localArrayDriver[5] = (
                                                    <div className='drivers_for_compliance_check_documents'>
                                                        {new Date(vanImage.expiryDate).toLocaleDateString('en-GB') === 'Mon Sep 09 2052' ? 'n/a' : new Date(vanImage.expiryDate).toLocaleDateString('en-GB')}
                                                    </div>
                                                )
                                            } else {
                                                localArrayDriver[5] = (
                                                    <div className='drivers_for_compliance_check_documents_two'>
                                                        {new Date(vanImage.expiryDate).toLocaleDateString('en-GB') === 'Mon Sep 09 2052' ? 'n/a' : new Date(vanImage.expiryDate).toLocaleDateString('en-GB')}
                                                    </div>
                                                )
                                            }
                                        }
                                        if (vanImage.name === 'P.L. Insurance') {
                                            if (vanImage.verified === 'True') {
                                                localArrayDriver[6] = (
                                                    <div className='drivers_for_compliance_check_documents'>
                                                        {new Date(vanImage.expiryDate).toLocaleDateString('en-GB') === 'Mon Sep 09 2052' ? 'n/a' : new Date(vanImage.expiryDate).toLocaleDateString('en-GB')}
                                                    </div>
                                                )
                                            } else {
                                                localArrayDriver[6] = (
                                                    <div className='drivers_for_compliance_check_documents_two'>
                                                        {new Date(vanImage.expiryDate).toLocaleDateString('en-GB') === 'Mon Sep 09 2052' ? 'n/a' : new Date(vanImage.expiryDate).toLocaleDateString('en-GB')}
                                                    </div>
                                                )
                                            }
                                        }
                                        if (vanImage.name === 'V5') {
                                            if (vanImage.verified === 'True') {
                                                localArrayDriver[7] = (
                                                    <div className='drivers_for_compliance_check_documents_check'>
                                                        <img src={check}  className='complianceImages' alt='this is a check'/>
                                                    </div>
                                                )
                                            } else {
                                                localArrayDriver[7] = (
                                                    <div className='drivers_for_compliance_check_documents_check_two'>
                                                        <img src={check}  className='complianceImages' alt='this is a check'/>
                                                    </div>
                                                )
                                            }
                                        }
                                        if (vanImage.name === 'TAX') {
                                            if (vanImage.verified === 'True') {
                                                localArrayDriver[8] = (
                                                    <div className='drivers_for_compliance_check_documents'>
                                                        {new Date(vanImage.expiryDate).toLocaleDateString('en-GB') === 'Mon Sep 09 2052' ? 'n/a' : new Date(vanImage.expiryDate).toLocaleDateString('en-GB')}
                                                    </div>
                                                )
                                            } else {
                                                localArrayDriver[8] = (
                                                    <div className='drivers_for_compliance_check_documents_two'>
                                                        {new Date(vanImage.expiryDate).toLocaleDateString('en-GB') === 'Mon Sep 09 2052' ? 'n/a' : new Date(vanImage.expiryDate).toLocaleDateString('en-GB')}
                                                    </div>
                                                )
                                            }
                                        }
                                    }
                                })
                            }    
                        })
                    }
                }
            localArrayReturn.push(
                <div className='vanHolder'>{localArrayDriver}</div>)
            })
        }
        setReturnArray(localArrayReturn)
    }, [props])

    return (
        <>
            {returnArray}
        </>
    )
}

export default VanDocumentsCompliance